import solutionUrlsService from "app/pages/sales-intelligence/services/solution-urls";
import { allTrackers } from "app/services/track/track";

/**
 * Opens the trial-upgrade purchase journey in a new tab and dispatches a
 * cross-surface tracking event so that "upgrade now" clicks coming from
 * different parts of Sales Intelligence (export hooks, low-quota banners,
 * tooltip CTAs, …) can be attributed to a single funnel while still being
 * disambiguated by `source`.
 *
 * The per-surface tracking (e.g. `Export hook/upgrade`) stays the
 * responsibility of the calling surface — this helper only adds the
 * unified Trial funnel event and centralises the `window.open` invocation.
 */
export const openTrialUpgradeUrl = (source: string): void => {
    allTrackers.dispatchTrackEvent("Trial", "click", `upgrade now/${source}`);
    window.open(solutionUrlsService.getTrialUpgradeUrl(), "_blank", "noopener,noreferrer");
};
